import { FC } from "react";
import { Website } from "webModule/websites";
import { Card } from "../../shared/components/card.component";
import "./websiteComponent.style.css";

interface Props {
    website: Website;
}

const WebsiteComponent: FC<Props> = ({ website }) => {
    const { title, thumbnail, description, url } = website;
    return (
        <Card>
            <div className="website-card-flex">
                <div className="website-card-img-container">
                    <img src={thumbnail} alt={title} />
                </div>
                <div className="website-card-content">
                    <h2 className="website-card-title">{title}</h2>
                    <p>{description}</p>
                    <a href={url} target="_blank" rel="noopener noreferrer" className="website-card-link">Visit Website</a>
                </div>
            </div>
        </Card>
    );
}

export default WebsiteComponent;
